import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import staffMonitoringRoutes from './affected-staffs/affected-staffs.routes'
import contractRoutes from './contracts/contract.routes'
import CreateStaffProfilePage from './create-staff-profile'
import { MissionTrackingsSalariesListPage } from './mission-trackings-salaries-list'
import StaffBankDetailsListPage from './staff-bank-details-list'
import StaffDocumentListPage from './staff-document-list'
import { StaffPayScaleCreatePage } from './staff-pay-scale-create'
import { StaffPayScaleUpdatePage } from './staff-pay-scale-update'
import { StaffPayScalesListPage } from './staff-pay-scales-list'
import StaffRequestDetailsPage from './staff-request-details'
import StaffRequestListPage from './staff-request-list'
import { StaffsListPage } from './staffs-list'
import UpdateStaffProfile from './update-staff-profile'

const staffRoutes: Route[] = [
  ...contractRoutes,
  ...staffMonitoringRoutes,
  {
    path: Paths.STAFF_LIST_PAGE,
    element: <StaffsListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.STAFF_PAY_SCALE_LIST_PAGE,
    element: <StaffPayScalesListPage />
  },
  {
    path: Paths.STAFF_PAY_SCALE_CREATE_PAGE,
    element: <StaffPayScaleCreatePage />
  },
  {
    path: Paths.STAFF_PAY_SCALE_UPDATE_PAGE,
    element: <StaffPayScaleUpdatePage />
  },
  {
    path: Paths.STAFF_CREATE_PAGE,
    element: <CreateStaffProfilePage />
  },
  {
    path: Paths.STAFF_DOCUMENT_LIST_PAGE,
    element: <StaffDocumentListPage />
  },
  {
    path: Paths.STAFF_UPDATE_PAGE,
    element: <UpdateStaffProfile />
  },
  {
    path: Paths.STAFF_REQUEST_LIST_PAGE,
    element: <StaffRequestListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.STAFF_REQUEST_DETAIL_PAGE,
    element: <StaffRequestDetailsPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.STAFF_BANK_DETAILS_LIST_PAGE,
    element: <StaffBankDetailsListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.MISSION_TRACKINGS_SALARIES_LIST_PAGE,
    element: <MissionTrackingsSalariesListPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default staffRoutes
